<template>
    <form ref="form" class="form">
        <b-form-group>
            <b-row>
                <b-col sm="4"> <label for="fieldLabel"> Form Seçiniz</label> </b-col>
                <b-col sm="8"> 
                     <Multiselect  
                        v-model="form"
                        :show-labels="false" 
                        :options="forms"
                        label="name"
                        track-by="id" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.name }} </strong> 
                            </template>
                    </Multiselect>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="4"> <label for="columnName">  Field Adı </label> </b-col>
                <b-col sm="8"> <b-form-input id="columnName" v-model="columnName" placeholder="Field adını giriniz" /></b-col>
            </b-row>
            <b-row>
                <b-col sm="4"> Field Başlığı (Formda Görünecek)</b-col>
                <b-col sm="8"> <b-form-input id="fieldLabel" v-model="fieldLabel" placeholder="Field Başlığı giriniz" /></b-col>
            </b-row>
            <b-row>
                <b-col sm="4"> <label for="hint"> Açıklama </label> </b-col>
                <b-col sm="8"> <b-form-input id="hint" v-model="hint" placeholder="Açıklama giriniz" /></b-col>
            </b-row>
             <b-row>
                <b-col sm="4"> <label for="hint"> Varsayılan Değer </label> </b-col>
                <b-col sm="8"> <b-form-input id="hint" v-model="defaultVal" placeholder="Varsayılan Değer giriniz" /></b-col>
            </b-row>
            <b-row>
                <b-col sm="4"> <label for="hint"> Tip </label> </b-col>
                <b-col sm="8"> 
                    <Multiselect  
                        v-model="type"
                        :show-labels="false" 
                        :options="types"
                        label="name"
                        track-by="id" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.name }} </strong> 
                            </template>
                    </Multiselect>
                </b-col>
            </b-row>
             <b-row>
                <b-col sm="4"> <label for="state"> Durumu </label> </b-col>
                <b-col sm="8"> 
                    <b-form-radio-group
                        id="state"
                        v-model="state"
                        :options="states"
                        aria-describedby="live-feedback">
                    </b-form-radio-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="4"> <label for="required"> Zorunlu Alan </label> </b-col>
                <b-col sm="8">
                    <b-form-radio-group
                        id="required"
                        v-model="required"
                        :options="yesNo"
                        aria-describedby="live-feedback">
                    </b-form-radio-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="4">  Listelemede Görünsün </b-col>
                <b-col sm="8"> 
                    <b-form-radio-group
                        id="show"
                        v-model="show"
                        :options="yesNo"
                        aria-describedby="live-feedback">
                    </b-form-radio-group>
                </b-col>
            </b-row>
        </b-form-group>
    </form>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    export default {
        name: "CustomField",
        props:{
            data: Object,
            modalName: String,
            modalEvent: Function,
            save: Boolean,
            saveState: Function
        },
        created: async function(){
            await this.$store.dispatch('listForms')
        },
        data: function(){
            return {
                state: false,
                required: false,
                show: false,
                type: null,
                form: null,
                columnName: "",
                fieldLabel: "",
                hint: "",
                defaultVal: "",
                types: [
                    {name: 'Metin', value: 'text'},
                    {name: 'Çoklu Metin', value: 'textarea'},
                    {name: 'Liste', value: 'dropdown'},
                    {name: 'Tarih', value: 'date'},
                    {name: 'Check List', value: 'checkbox'},
                ],
                states: [
                    {text: 'Aktif', value: true},
                    {text: 'Pasif', value: false},
                ],
                yesNo: [
                    {text: 'Evet', value: true},
                    {text: 'Hayır', value: false},
                ]
            }
        },
        computed:{
            forms: function(){
                return this.$store.getters.getForms
            }
        },
        components:{
            Multiselect
        },
        watch:{
            save: async function(data){
                if(data){
                    let val = {
                        default_value: this.defaultVal,
                        field_column: this.columnName,
                        field_label: this.fieldLabel,
                        form_id: this.form.id,
                        hint: this.hint,
                        is_active: this.state,
                        is_required: this.required,
                        show_on_list: this.show,
                        type: this.type.value
                    }
                    
                    switch(this.modalName){
                        case "add":
                            await this.$store.dispatch('addCustomFields', val)
                            break;  
                        case "edit":
                            val.id = this.data.id
                            await this.$store.dispatch('editZoneTypes', val)
                            break;  
                    }
                    if(this.$store.getters.getStatus.status == "Success"){
                        this.$store.dispatch('listCustomFields')
                        this.clearForm()
                    }
                }
                this.saveState(false)
            }
        },
         methods:{
                clearForm(){
                    this.type = ""
                    this.modalEvent(false)
                }
            }
    }
</script>

<style lang="css" scoped > 
    @import "../styles/modalForm.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/CustomField.vue